import chunkHistoryIntoPairs from "../../utils/utils";
import {
  TYPE_CHAT_STREAM_START,
  TYPE_CHAT_STREAM_UPDATE,
  TYPE_CHAT_SUCCESS,
  TYPE_CHAT_FAILURE,
  TYPE_CHAT_CLEAR,
  CHAT_HISTORY_SUCCESS,
  CHAT_HISTORY_FAILURE,
  CHAT_HISTORY_ONE_SUCCESS,
  CHAT_HISTORY_ONE_FAILURE,
  CHAT_HISTORY_SEVEN_SUCCESS,
  CHAT_HISTORY_SEVEN_FAILURE,
  CHAT_HISTORY_MONTH_SUCCESS,
  CHAT_HISTORY_MONTH_FAILURE,
  ANSWER_SPEAKER_FAILURE,
  ANSWER_SPEAKER_SUCCESS,
} from "./chat.actionTypes";

const initialState = {
  chatLoading: false,
  response: "",
  question: "",
  sessionHistory: [],
  error: null,
  historyOneday: [],
  historySevenday: [],
  historyMonth: [],
  audioBlob: null,
  audioUrl: null,
};

export const chatReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPE_CHAT_STREAM_START:
      return {
        ...state,
        chatLoading: true,
        response: "",
        question: "",
        sessionHistory: [],
        error: null,
      };

    case TYPE_CHAT_STREAM_UPDATE:
      return {
        ...state,
        response: state.response + (action.payload.chunk || ""),
      };

    case TYPE_CHAT_SUCCESS:
      return {
        ...state,
        chatLoading: false,
        response: action.payload.data,
        question: action.payload.questionData,
        sessionHistory: [
          ...state.sessionHistory,
          ...chunkHistoryIntoPairs(action.payload.history || []),
        ],
      };

    // case ANSWER_SPEAKER_SUCCESS:
    //   return {
    //     ...state,
    //     audioBlob: action.payload.blob,
    //     audioUrl: action.payload.url,
    //     error: null,
    //   };
    // case ANSWER_SPEAKER_FAILURE:
    //   return {
    //     ...state,
    //     audioBlob: null,
    //     audioUrl: null,
    //     error: action.payload.message,
    //   };

    case CHAT_HISTORY_MONTH_FAILURE:
      return {
        ...state,
        message: "",
      };
    case TYPE_CHAT_CLEAR:
      return {
        ...initialState,
      };

    case CHAT_HISTORY_ONE_SUCCESS:
      return {
        ...state,
        historyOneday: action.payload.data,
      };
    case CHAT_HISTORY_ONE_FAILURE:
      return {
        ...state,
        message: "",
      };

    case CHAT_HISTORY_SEVEN_SUCCESS:
      return {
        ...state,
        historySevenday: action.payload.data,
      };
    case CHAT_HISTORY_SEVEN_FAILURE:
      return {
        ...state,
        message: "",
      };

    case CHAT_HISTORY_MONTH_SUCCESS:
      return {
        ...state,
        historyMonth: action.payload.data,
      };
    case CHAT_HISTORY_MONTH_FAILURE:
      return {
        ...state,
        message: "",
      };

    default:
      return state;
  }
};
